import { SermonData } from "../global/dataTypes"


export function paginate(sermons: SermonData[], pageNumber: number, pageSize: number) {
    const startIndex = (pageNumber - 1) * pageSize
    const test =  [...sermons].slice(startIndex, startIndex + pageSize)
    return test
}